import { render, staticRenderFns } from "./latest_article.vue?vue&type=template&id=268cda0a&lang=pug"
import script from "./latest_article.vue?vue&type=script&lang=js"
export * from "./latest_article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports